import { useCallback, useContext, useState } from 'react'
import { IMetricas } from '../../AdminLocal/types'
import { TenantsContext } from '../../../context/tenants.context'
import {
  getBusquedasCluster,
  getLocalesContactados,
  getLocalesSeguidos,
  getMetricas,
  getProductosContactados,
  getProductosFav,
  getProductosMasVistos,
  getRubrosMasVistos,
  getRubrosMetricas
} from '../services/metricas.services'

export const useMetricas = (codLocal: string) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [loadings, setLoadings] = useState<Record<string, boolean>>({
    prodVistos: false,
    prodFavs: false,
    prodContactados: false,
    rubrosVistos: false,
    localesContactados: false,
    localesSeguidos: false,
    busquedaClusterizada: false
  })
  const [metricas, setMetricas] = useState<IMetricas>()
  const [prodVistos, setProdVistos] = useState<any[]>(null)
  const [prodFavs, setProdFavs] = useState<any[]>(null)
  const [prodContactados, setProdContactados] = useState<any[]>(null)
  const [rubrosVistos, setRubrosVistos] = useState<any[]>(null)
  const [localesContactados, setLocalesContactados] = useState<any[]>(null)
  const [localesSeguidos, setLocalesSeguidos] = useState<any[]>(null)
  const [busquedaClusterizada, setBusquedaClusterizada] = useState<any[]>(null)
  const [rubrosFiltros, setRubrosFiltros] = useState<{ codigo: string; nombre: string }[]>(null)
  const { tenant } = useContext(TenantsContext)

  const fetchMetricas = useCallback(
    async (detallado: boolean) => {
      if (metricas || !codLocal) return
      try {
        setLoading(true)
        await getMetricas(codLocal, tenant, detallado).then((res) => setMetricas(res.data))
      } catch {
        console.log()
      } finally {
        setLoading(false)
      }
    },
    [codLocal]
  )

  const fecthProdVistos = useCallback(
    async (filtros: { periodo: string; limit: number; miLocal: boolean; codRubro: string }) => {
      try {
        setLoadings({ ...loadings, prodVistos: true })
        const res = await getProductosMasVistos(
          tenant,
          filtros.periodo,
          filtros.miLocal,
          filtros.codRubro,
          filtros.limit
        )
        setProdVistos(res.data.data)
      } catch (e) {
        console.log(e)
      } finally {
        setLoadings({ ...loadings, prodVistos: false })
      }
    },
    [tenant]
  )

  const fecthProdFav = useCallback(
    async (filtros: { periodo: string; limit: number; miLocal: boolean; codRubro: string }) => {
      try {
        setLoadings({ ...loadings, prodFavs: true })
        const res = await getProductosFav(tenant, filtros.periodo, filtros.miLocal, filtros.codRubro, filtros.limit)
        setProdFavs(res.data.data)
      } catch (e) {
        console.log(e)
      } finally {
        setLoadings({ ...loadings, prodFavs: false })
      }
    },
    [tenant]
  )

  const fecthProdContactados = useCallback(
    async (filtros: { periodo: string; limit: number; miLocal: boolean; codRubro: string }) => {
      try {
        setLoadings({ ...loadings, prodContactados: true })
        const res = await getProductosContactados(
          tenant,
          filtros.periodo,
          filtros.miLocal,
          filtros.codRubro,
          filtros.limit
        )
        setProdContactados(res.data.data)
      } catch (e) {
        console.log(e)
      } finally {
        setLoadings({ ...loadings, prodContactados: false })
      }
    },
    [tenant]
  )

  const fecthRubrosVistos = useCallback(
    async (filtros: { periodo: string; limit: number }) => {
      try {
        setLoadings({ ...loadings, rubrosVistos: true })
        const res = await getRubrosMasVistos(tenant, filtros.periodo, filtros.limit)
        setRubrosVistos(res.data.data)
      } catch (e) {
        console.log(e)
      } finally {
        setLoadings({ ...loadings, rubrosVistos: false })
      }
    },
    [tenant]
  )

  const fecthLocalesContactados = useCallback(
    async (filtros: { periodo: string; limit: number }) => {
      try {
        setLoadings({ ...loadings, localesContactados: true })
        const res = await getLocalesContactados(tenant, filtros.periodo, filtros.limit)
        setLocalesContactados(res.data.data)
      } catch (e) {
        console.log(e)
      } finally {
        setLoadings({ ...loadings, localesContactados: false })
      }
    },
    [tenant]
  )

  const fecthLocalesSeguidos = useCallback(
    async (filtros: { periodo: string; limit: number }) => {
      try {
        setLoadings({ ...loadings, localesSeguidos: true })
        const res = await getLocalesSeguidos(tenant, filtros.periodo, filtros.limit)
        setLocalesSeguidos(res.data.data)
      } catch (e) {
        console.log(e)
      } finally {
        setLoadings({ ...loadings, localesSeguidos: false })
      }
    },
    [tenant]
  )

  const fecthBusquedaCluster = useCallback(async () => {
    try {
      setLoadings({ ...loadings, busquedaClusterizada: true })
      const res = await getBusquedasCluster(tenant)
      setBusquedaClusterizada(res.data.data)
    } catch (e) {
      console.log(e)
    } finally {
      setLoadings({ ...loadings, busquedaClusterizada: false })
    }
  }, [tenant])

  const fecthRubrosFiltros = useCallback(async () => {
    try {
      const res = await getRubrosMetricas(tenant, codLocal)
      setRubrosFiltros(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }, [tenant, codLocal])

  return {
    metricas,
    loading,
    loadings,
    prodVistos,
    prodFavs,
    prodContactados,
    rubrosVistos,
    localesContactados,
    localesSeguidos,
    busquedaClusterizada,
    rubrosFiltros,
    fetchMetricas,
    fecthProdVistos,
    fecthProdFav,
    fecthProdContactados,
    fecthRubrosVistos,
    fecthLocalesSeguidos,
    fecthLocalesContactados,
    fecthBusquedaCluster,
    fecthRubrosFiltros
  }
}
